import React from 'react';
import { DrawerHeader, DrawerCloseButton } from '@fiverr-private/overlay';
import { appTranslate } from '../../i18n';

export const SubscriptionHeader = () => (
    <DrawerHeader>
        {appTranslate('subscription_drawer.heading')}
        <DrawerCloseButton />
    </DrawerHeader>
);
